"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _lazyGettext = _interopRequireDefault(require("js-utils/lazy-gettext"));

var _Button = _interopRequireDefault(require("eventbrite_design_system/button/Button"));

var _Icon = _interopRequireDefault(require("eventbrite_design_system/icon/Icon"));

var _LogoApple = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/LogoApple"));

var _constants = require("eventbrite_design_system/button/constants");

require("./AppleLoginButton.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AppleLoginButton =
/*#__PURE__*/
function (_Component) {
  _inherits(AppleLoginButton, _Component);

  function AppleLoginButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AppleLoginButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AppleLoginButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "appleInit", function () {
      var _this$props = _this.props,
          clientId = _this$props.clientId,
          scope = _this$props.scope,
          redirectURI = _this$props.redirectURI;
      AppleID.auth.init({
        clientId: clientId,
        scope: scope,
        redirectURI: redirectURI
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var onClick = _this.props.onClick;
      onClick();
      AppleID.auth.signIn();
    });

    return _this;
  }

  _createClass(AppleLoginButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (function (doc, tagName, id, appleInit) {
        var firstScriptTag = doc.getElementsByTagName(tagName)[0];

        if ((0, _isNull.default)(doc.getElementById(id))) {
          // if the script tag is not present
          var scriptTag = doc.createElement('script');
          scriptTag.id = id;
          scriptTag.src = '"https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"';
          firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
        }

        if (appleInit) {
          appleInit();
        }
      })(document, 'script', 'apple-id-auth', this.appleInit);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "apple-login__container"
      }, _react.default.createElement(_Button.default, {
        tyspe: "button",
        size: _constants.SIZE_BLOCK,
        onClick: this.handleClick
      }, _react.default.createElement("div", {
        className: "apple-login__icon"
      }, _react.default.createElement(_Icon.default, {
        type: _react.default.createElement(_LogoApple.default, null),
        size: "small",
        color: "white"
      })), (0, _lazyGettext.default)('Continue with Apple')));
    }
  }]);

  return AppleLoginButton;
}(_react.Component);

exports.default = AppleLoginButton;

_defineProperty(AppleLoginButton, "propTypes", {
  onClick: _propTypes.default.func.isRequired
});
//# sourceMappingURL=AppleLoginButton.js.map